import { toAbsoluteUrl } from '@/lib/helpers';

export const resolveAvatarSrc = (value?: string | null): string | undefined => {
  if (!value) return undefined;

  // Keep absolute URLs (e.g. from OAuth) intact
  if (/^(https?:)?\/\//.test(value) || value.startsWith('data:')) return value;

  // Normalize relative paths to be root-relative so they work with the base path
  const normalized = value.startsWith('/')
    ? value
    : `/${value.replace(/^\/+/, '')}`;
  return toAbsoluteUrl(normalized);
};

export const getInitials = (name?: string | null, email?: string | null) => {
  if (name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }
  if (email) {
    return email.substring(0, 2).toUpperCase();
  }
  return 'U';
};
